// Admin pages a sub admin may open. Each page's data is scoped to the sub
// admin's assigned workspaces on the server (RLS + scoped admin RPCs).
export const SUB_ADMIN_ALLOWED_PREFIXES = [
  "/admin/organizations",
  "/admin/connected-accounts",
  "/admin/disconnected-accounts",
  "/admin/target-refill",
  "/admin/customer-activity",
  "/admin/crm-calendar",
  "/admin/account-renewals",
  "/settings",
];

export const isSubAdminAllowedPath = (pathname: string): boolean => {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (p === "/admin") return true;
  return SUB_ADMIN_ALLOWED_PREFIXES.some((pre) => p === pre || p.startsWith(pre + "/"));
};
